import { TFunction } from "i18next";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model["status"], t?: TFunction): string =>
	t && item ? t(`order_status.${item}`) ?? "" : "";

export default cellProcessing;
